import React, { Component } from 'react';
import { connect } from 'react-redux';
import { omit } from 'lodash';
import baseActions from '../actions';
import {
  RAW_DATA_TYPES, ITEMS, PERSIST_PARAMS, ITEM_LOOKUPS, RAW_DATA, BULK_EDIT, BULK_DELETE, COPY_PREVIOUS_WEEK,
  URLS, DATA_IS_LINKED, UNLINK_DATA, OPTIMISE_STATUS, CHECK_IS_OPTIMISE, GLOBAL_FILTERS, SCENARIOS,
  AVAILABLE_VOLUME_DATA_SOURCES, VOLUME_FROM_SOURCE, CURRENT_VOLUMES, UPDATE_VOLUMES, CONFIG,
} from '../plannerConfig';
import DataPageComponent from '../components/DataPage';
import {
  updateLink, getSetSequence, generateRouteParams,
} from '../helpers';
import { EXTRA_DATA_PAGES } from '../constants/dataPages.constants';
import { DATE_FORMAT } from '../constants/grid.constants';

const mapStateToProps = state => ({
  [CONFIG]: state[CONFIG].data,
  [DATA_IS_LINKED]: state[DATA_IS_LINKED].data,
  [RAW_DATA_TYPES]: state[RAW_DATA_TYPES].data,
  [RAW_DATA]: state[RAW_DATA],
  [ITEMS]: state[ITEMS].data,
  [ITEM_LOOKUPS]: state[ITEM_LOOKUPS],
  [PERSIST_PARAMS]: state[PERSIST_PARAMS].data,
  [OPTIMISE_STATUS]: state[OPTIMISE_STATUS].data,
  [CHECK_IS_OPTIMISE]: state[CHECK_IS_OPTIMISE].data,
  [AVAILABLE_VOLUME_DATA_SOURCES]: state[AVAILABLE_VOLUME_DATA_SOURCES].data,
  [VOLUME_FROM_SOURCE]: state[VOLUME_FROM_SOURCE].data,
  [CURRENT_VOLUMES]: state[CURRENT_VOLUMES],
  [UPDATE_VOLUMES]: state[UPDATE_VOLUMES].loadingQueue,
  [UNLINK_DATA]: state[UNLINK_DATA].loadingQueue,
  [BULK_DELETE]: state[BULK_DELETE].loadingQueue,
});

const mapDispatchToProps = {
  get: baseActions.get,
  put: baseActions.put,
  post: baseActions.post,
  apiDelete: baseActions.delete,
  set: baseActions.set,
};

class DataPage extends Component {
  state = {
    requestError: null,
  }

  componentDidMount() {
    const { get, persistParams } = this.props;
    getSetSequence(this.props, [
      [SCENARIOS],
    ]);

    const routeParams = generateRouteParams(this.props);
    if (EXTRA_DATA_PAGES[routeParams.dataType]) {
      const { api } = EXTRA_DATA_PAGES[routeParams.dataType];
      get(
        [RAW_DATA_TYPES, ...api.get.routes],
        {
          routeParams: {
            ...routeParams,
            ...api.get.params(persistParams),
          },
        },
      );
      return true;
    }

    get(
      [RAW_DATA, RAW_DATA_TYPES, ITEM_LOOKUPS, DATA_IS_LINKED],
      {
        routeParams: {
          ...routeParams,
          queryParameters: {
            limit: persistParams.limit,
          },
        },
        errorCallback: error => this.setState({ requestError: error }),
      },
    );
    return true;
  }

  componentDidUpdate(prevProps) {
    const { match, get, persistParams } = this.props;
    if (prevProps.match.url === match.url) return false;
    getSetSequence(this.props, [
      [GLOBAL_FILTERS],
    ]);
    const routeParams = generateRouteParams(this.props);
    if (EXTRA_DATA_PAGES[routeParams.dataType]) {
      const { api } = EXTRA_DATA_PAGES[routeParams.dataType];
      get(
        [RAW_DATA_TYPES, ...api.get.routes],
        {
          routeParams: {
            ...routeParams,
            ...api.get.params(persistParams),
          },
        },
      );
      return true;
    }
    get(
      [RAW_DATA, ITEM_LOOKUPS, RAW_DATA_TYPES, DATA_IS_LINKED],
      {
        routeParams: {
          ...routeParams,
          queryParameters: {
            limit: persistParams.limit,
          },
        },
        errorCallback: error => this.setState({ requestError: error }),
      },

    );
    return true;
  }

  render() {
    const {
      config,
      dataIsLinked,
      rawDataTypes,
      rawData,
      itemLookUps,
      match: { params },
      get,
      put,
      post,
      set,
      persistParams,
      optimiseStatus: { status, activePlanOtherWeekIsOptimising },
      availableVolumeDataSources,
      volumeFromSource,
      currentVolume,
      updateVolumes,
      unlinkData,
      bulkDelete,
    } = this.props;

    const { requestError } = this.state;

    const {
      uploadLink,
      downloadLink,
      downloadForCopyToClipboard,
    } = URLS.tsv;

    const {
      downloadCSVLink,
    } = URLS.csv;

    const routeParams = generateRouteParams(this.props);

    return (
      <DataPageComponent
        config={config}
        persistParams={persistParams}
        dataIsLinked={dataIsLinked}
        dataTypes={rawDataTypes}
        dataView={rawData}
        callbackErrorObject={requestError}
        removeErroredStatus={() => this.setState({ requestError: null })}
        currentItemType={params.dataType}
        weekPickerStartDate={params.startDate}
        routeParams={persistParams}
        itemLookUps={itemLookUps}
        isCheckingOptimising={status === 'CHECKING'}
        isOptimising={status === 'RUNNING' || status === 'PREPARING' || activePlanOtherWeekIsOptimising}
        availableVolumeDataSources={availableVolumeDataSources}
        volumeFromSource={volumeFromSource}
        currentVolume={currentVolume}
        updateVolumeStatus={updateVolumes}
        unlinkDataStatus={unlinkData}
        bulkDelete={bulkDelete}

        onUpdateVolumes={(data, timePeriod, callback) => put(
          [UPDATE_VOLUMES],
          {
            routeParams: {
              ...persistParams,
              timePeriod,
            },
            body: { ...data },
            callback,
          },
        )}

        onApplyVolume={({
          days, source, weeks, volumeType, dateType, timePeriod,
        }, callback) => {
          return get(
            [VOLUME_FROM_SOURCE, CURRENT_VOLUMES, AVAILABLE_VOLUME_DATA_SOURCES, DATA_IS_LINKED],
            {
              routeParams: {
                ...persistParams,
                days,
                source,
                volumeType,
                dateType,
                dataType: volumeType,
                timePeriod,
              },
              callback,
            },
          );
        }}

        onMenuClick={e => updateLink(
          {
            dataType: e.key,
          },
          this.props,
        )}

        onWeekPickerSelect={d => updateLink(
          {
            startOfWeekDate: d.start,
            offset: 0,
            range: 7,
          },
          this.props,
        )}

        onBulkEdit={(data, successCallback) => put(
          [BULK_EDIT],
          {
            routeParams: {
              ...persistParams,
            },
            body: data,
            callback: successCallback,
          },
        )}

        onCopyPreviousWeek={(successCallback, failedCallBack) => put(
          [COPY_PREVIOUS_WEEK],
          {
            routeParams: {
              ...persistParams,
            },
            callback: successCallback,
            errorCallback: failedCallBack,
          },
        )}

        onCSV={{
          download: () => downloadLink(persistParams),
          upload: () => uploadLink(persistParams),
          downloadCSV: () => downloadCSVLink(persistParams),
          downloadForCopyToClipboard: () => downloadForCopyToClipboard(persistParams),
        }}

        unlinkData={(alsoCopy, queryParameters) => put(
          [UNLINK_DATA],
          {
            routeParams: {
              ...persistParams,
              alsoCopy,
            },
            body: {},
            callback: () => {
              get([DATA_IS_LINKED], { routeParams: { ...persistParams } });
              get(
                [RAW_DATA],
                {
                  routeParams: {
                    ...routeParams,
                    queryParameters: {
                      limit: persistParams.limit,
                      ...queryParameters,
                    },
                  },
                },
              );
            },
          },
        )}

        onPageLimit={limit => set(
          [PERSIST_PARAMS],
          {
            ...persistParams,
            limit,
          },
        )}

        onCheckToToggleColumns={({ addToHideList, removeFromHideList }) => (
          (removeFromHideList.length > 0) && set(
            [PERSIST_PARAMS],
            {
              ...persistParams,
              dataPageHideColumns: (persistParams.dataPageHideColumns || [])
                .concat(addToHideList)
                .filter(key => !removeFromHideList.includes(key)),
            },
          )
        )}

        gridApi={{
          set,
          get: ({ queryParameters, successCallback }) => get(
            [RAW_DATA],
            {
              routeParams: {
                ...routeParams,
                queryParameters: {
                  limit: persistParams.limit,
                  ...queryParameters,
                },
              },
              errorCallback: (error) => { this.setState({ requestError: error }); },
              callback: successCallback,
            },
          ),
          getWithLookups: ({ queryParameters, successCallback }) => get(
            [RAW_DATA, ITEM_LOOKUPS],
            {
              routeParams: {
                ...routeParams,
                queryParameters: {
                  limit: persistParams.limit,
                  ...queryParameters,
                },
              },
              errorCallback: (error) => { this.setState({ requestError: error }); },
              callback: successCallback,
            },
          ),
          put: ({ data, successCallback }, dataType) => put(
            [ITEMS],
            {
              routeParams: {
                ...persistParams,
                id: data.id,
                dataType,
              },
              body: omit(data, ''),
              callback: successCallback,
            },
          ),
          post: ({ data, successCallback }, child) => post(
            [ITEMS],
            {
              routeParams: {
                ...persistParams,
                dataType: child,
              },
              body: data,
              callback: successCallback,
            },
          ),
          bulkDelete: ({ data, successCallback }, dataType) => put(
            [BULK_DELETE],
            {
              routeParams: {
                ...persistParams,
                dataType,
              },
              body: omit(data, ''),
              callback: successCallback,
            },
          ),
        }}
      />
    );
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(DataPage);
